module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-tooltip",
    on: {
      "mouseenter": _vm.handleShowPopper,
      "mouseleave": _vm.handleClosePopper
    }
  }, [_c('div', {
    ref: "reference",
    staticClass: "el-tooltip-rel"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transition
    },
    on: {
      "after-leave": _vm.doDestroy
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.disabled && _vm.showPopper),
      expression: "!disabled && showPopper"
    }],
    ref: "popper",
    staticClass: "el-tooltip-popper",
    class: ['is-' + _vm.effect]
  }, [_vm._t("content", [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.content)
    }
  })])], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c28e6e5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tooltip/src/tooltip.vue
// module id = 663
// module chunks = 0